import React from 'react'
import { InvoiceListItem } from '../../../../../lib/types/Invoice'
import { useDownloadInvoice } from '../../../../../services/api/invoices'
import { View } from './View'
import { notification } from 'antd'
import { downloadPdf } from '../../../../../utils/downloadPdf'

type Props = {
  invoice: InvoiceListItem
}

export const Container: React.FunctionComponent<Props> = ({ invoice }) => {
  const [downloadInvoice, { isLoading }] = useDownloadInvoice(invoice.id)

  const onSubmit = () => {
    downloadInvoice({
      companyId: invoice.companyId,
    })
      .then((data) => {
        downloadPdf(data, `Счет на оплату №${invoice.id}`)
      })
      .catch(() => {
        notification.error({
          message: 'Возникли ошибки при скачивании документа',
          duration: 3,
        })
      })
  }

  return <View onSubmit={onSubmit} isLoading={isLoading} />
}
